import request from '@/utils/request'

//getShipList
export function getShipList(param){
    let data = param
    return request({
        url:`/v80/v80comm/getShipList`,
        method: 'POST',
        meta: {apiVersion: '1.0.0'},
        headers: {'Content-Type': 'application/json;charset=utf8'},
        data
    })
}

//getDeptList
export function getDeptList(param){
    let data = param
    return request({
        url:`/v80/v80comm/getDeptList`,
        method: 'POST',
        meta: {apiVersion: '1.0.0'},
        headers: {'Content-Type': 'application/json;charset=utf8'},
        data
    })
}

//getRespList
export function getRespList(param){
    let data = param
    return request({
        url:`/v80/v80comm/getRespList`,
        method: 'POST',
        meta: {apiVersion: '1.0.0'},
        headers: {'Content-Type': 'application/json;charset=utf8'},
        data
    })
}

//getQMPartList
export function getQMPartList(param){
    let data = param
    return request({
        url:`/v80/v80comm/getQMPartList`,
        method: 'POST',
        meta: {apiVersion: '1.0.0'},
        headers: {'Content-Type': 'application/json;charset=utf8'},
        data
    })
}

//getResultList
export function getResultList(param){
    let data = param
    return request({
        url:`/v80/v80comm/getResultList`,
        method: 'POST',
        meta: {apiVersion: '1.0.0'},
        headers: {'Content-Type': 'application/json;charset=utf8'},
        data
    })
}

// getStageList
export function getStageList(param){
    let data = param
    return request({
        url:`/v80/v80comm/getStageList`,
        method: 'POST',
        meta: {apiVersion: '1.0.0'},
        headers: {'Content-Type': 'application/json;charset=utf8'},
        data
    })
}

// getSecCommentList
export function getSecCommentList(param){
    let data = param
    return request({
        url:`/v80/v80comm/getSecCommentList`,
        method: 'POST',
        meta: {apiVersion: '1.0.0'},
        headers: {'Content-Type': 'application/json;charset=utf8'},
        data
    })
}

// getQmEmployeeList
export function getQmEmployeeList(param){
    let data = param
    return request({
        url:`/v80/v80comm/getQmEmployeeList`,
        method: 'POST',
        meta: {apiVersion: '1.0.0'},
        headers: {'Content-Type': 'application/json;charset=utf8'},
        data
    })
}

// getTelephoneList
export function getTelephoneList(param){
    let data = param
    return request({
        url:`/v80/v80comm/getTelephoneList`,
        method: 'POST',
        meta: {apiVersion: '1.0.0'},
        headers: {'Content-Type': 'application/json;charset=utf8'},
        data
    })
}

// getEventList
export function getEventList(param){
    let data = param
    return request({
        url:`/v80/v80comm/getEventList`,
        method: 'POST',
        meta: {apiVersion: '1.0.0'},
        headers: {'Content-Type': 'application/json;charset=utf8'},
        data
    })
}

// getDivList
export function getDivList(param){
    let data = param
    return request({
        url:`/v80/v80comm/getDivList`,
        method: 'POST',
        meta: {apiVersion: '1.0.0'},
        headers: {'Content-Type': 'application/json;charset=utf8'},
        data
    })
}

// getPublisherList
export function getPublisherList(param){
    let data = param
    return request({
        url:`/v80/v80comm/getPublisherList`,
        method: 'POST',
        meta: {apiVersion: '1.0.0'},
        headers: {'Content-Type': 'application/json;charset=utf8'},
        data
    })
}

//getMakerList
export function getMakerList(param){
    let data = param
    return request({
        url:`/v80/v80comm/getMakerList`,
        method: 'POST',
        meta: {apiVersion: '1.0.0'},
        headers: {'Content-Type': 'application/json;charset=utf8'},
        data
    })
}